/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { handleNetworkError } from '@/account/lib/network-error';
import { fetchGraphQl } from '@/account/api/fetch-graphql';
import { REMOVE_CUSTOMER_ADDRESS } from './graphql/removeCustomerAddress.graphql';
import { handleFetchError } from '@/account/lib/fetch-error';
import { RemoveCustomerAddressResponse } from '@/account/types';

export const removeCustomerAddress = async (
  addressId: number
): Promise<boolean> => {
  return await fetchGraphQl(REMOVE_CUSTOMER_ADDRESS, {
    method: 'POST',
    variables: { id: addressId },
  })
    .then((response: RemoveCustomerAddressResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return response.data.deleteCustomerAddress;
    })
    .catch(handleNetworkError);
};
